import { Button, HStack, Stack } from "@chakra-ui/react";
import React from "react";
import { CSelect } from "../common";
import { useFormik } from "formik";
import { newCOCStep0Schema } from "../../utils/schemas";

export default function NewCOCStep0({ onNextStep, formData, users }) {
  const formik = useFormik({
    initialValues: formData,
    validationSchema: newCOCStep0Schema,
    onSubmit: (values) => onNextStep(values),
  });

  return (
    <Stack w={{ base: "full", lg: "850px" }} mx="auto">
      <Stack mb={3}>
        <CSelect
          label="Client"
          name="userId"
          isRequired
          options={users}
          defaultValue={users.find(
            (item) => item.value === formik.values.userId
          )}
          onChange={(opt) => formik.setFieldValue("userId", opt.value)}
          touched={formik.touched.userId}
          errors={formik.errors.userId}
          isSearchable
        />
      </Stack>
      <HStack justifyContent="end">
        <Button
          type="submit"
          onClick={formik.handleSubmit}
          isLoading={formik.isSubmitting}
          loadingText="Loading..."
          bgColor="black"
          borderRadius="lg"
          fontWeight="medium"
          py="6"
          px="7"
        >
          Next
        </Button>
      </HStack>
    </Stack>
  );
}
